//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    props: {
        showAuthButtons: {
            type: Boolean,
            default: false
        },
        showPrivacyButtons: {
            type: Boolean,
            default: false
        }
    },

    data () {
        return {
            registerDialogVisible: false
        };
    },

    computed: {
        authenticated () {
            return this.$authUser && this.$authUser.id !== undefined;
        },
        route () {
            if (this.authenticated) {
                return '/logout';
            }

            return '/login';
        },
        buttonLabel () {
            if (this.authenticated) {
                return this.$lang.get('landingpage.nav.logout');
            }

            return this.$lang.get('landingpage.nav.login');
        }
    },

    methods: {
        scrollTo (anchor) {
            const element = document.getElementById(anchor);

            window.scrollTo({
                top: element.offsetTop,
                behavior: 'smooth'
            });

            this.$emit('clicked');
        }
    }
};
